import React from 'react';
import { TitleBlocLoader } from 'modules/shared-cms-advanced';
import { FilterableProductListLoader } from 'modules/catalogue/components';

export const BrandLoader: React.FC = React.memo(() => {
    return (
        <React.Fragment>
            <TitleBlocLoader />
            <FilterableProductListLoader />
        </React.Fragment>
    );
});
